import { axios } from '../request'

export default (app) => {
  return {
    namespaced: true,
    actions: {
      load(context) {
        axios.get(`explainer`).then((res) => {
          Object.keys(res.data.data).forEach((key) => {
            const item = res.data.data[key]
            if (typeof context.rootState[key] !== 'undefined') {
              context.dispatch(`${key}/explain`, item, { root: true })
            }
          })
        })
      },
    },
  }
}
